"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  black1000: '#000000',
  black900: '#333333',
  black800: '#403F4E',
  black700: '#8e929b',
  black500: '#b6b9c4',
  black300: '#ced1d8',
  black200: '#dcdfe4',
  black100: '#f3f3f4',
  teal900: '#005f74',
  teal700: '#1f7eac',
  teal500: '#00a6cb',
  teal100: '#e4f7fa',
  purple900: '#2a1670',
  purple700: '#38208a',
  purple500: '#4323b0',
  purple100: '#e7e2f5',
  blue900: '#003178',
  blue700: '#0053cb',
  blue500: '#2962ff',
  blue100: '#dfe7ff',
  red700: '#a42902',
  red500: '#e53935',
  red100: '#f1dfd9',
  yellow700: '#d52b01',
  yellow500: '#ffc107',
  yellow100: '#fff3e0',
  green700: '#038639',
  green500: '#04aa49',
  green100: '#e6f3eb',
  background700: '#f2f4f6',
  background500: '#fdfdfd',
  background100: '#ffffff',
  white: '#ffffff',
  // Legacy
  ui0: '#000000',
  ui1: '#333333',
  ui2: '#5C5F6C',
  ui3: '#A5A8B8',
  ui4: '#C8CAD3',
  ui5: '#E8E9EE',
  ui6: '#F3F4F7',
  ui7: '#FFFFFF',
  tint1: '#24c9fb',
  tint1Dark: '#09AEE0',
  tint2: '#4323B0',
  tint2Dark: '#38208A',
  unhappy: '#DC3545'
};
exports["default"] = _default;